<template>
  <div>
    <div class="md-layout md-gutter trade-type-content title-height">
      <div class="md-layout-item title-size adjust-layout">
        <h6 class="title-selection">Trade type</h6>
      </div>
      <div
        class="md-layout-item md-size-45 md-medium-size-25 md-small-size-25 md-xsmall-size-25 space-itens adjust-layout"
        :class="[getSelectedItemColor]"
      >
        <md-field data-cy="tradeType" id="material-select-field">
          <md-select
            v-model="option"
            name="Trade type"
            id="trade-type"
            @md-opened="selectOpen"
            @md-selected="storeType"
          >
            <md-option
              v-for="(type, index) in options"
              :key="index"
              :class="[{ 'is-selected': type.isSelected }, type.class]"
              :value="type.value"
              :data-cy="`newItemType-${type.option}`"
              >{{ type.option }}</md-option
            >
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
export default {
  name: "ReviewTradeType",
  mixins: [ItemHelperVue],
  data() {
    return {
      options: [
        {
          value: 1,
          option: "Give",
          class: "tertiary-color",
          isSelected: false,
          tooltip: false,
        },
        {
          value: 2,
          option: "Receive",
          class: "offer-color",
          isSelected: false,
          tooltip: false,
        },
        {
          value: 3,
          option: "Lend",
          class: "tertiary-color",
          isSelected: false,
          tooltip: false,
        },
        {
          value: 4,
          option: "Borrow",
          class: "offer-color",
          isSelected: false,
          tooltip: false,
        },
      ],
      option: null,
      isActive: false,
      isScrolling: false,
    };
  },
  methods: {
    ...mapActions(["setNewItemType"]),
    storeType(e) {
      if (e) this.option = e;
      if (this.itemType !== this.option) {
        this.setNewItemType(parseInt(this.option));
      }

      this.storeItemSession();
    },
    selectOpen() {
      this.$nextTick(function () {
        this.$nextTick(function () {
          this.$nextTick(function () {
            $(".md-select-menu").css(
              "top",
              $("#material-select-field").offset().top + 50
            );
            $(".md-select-menu").css(
              "left",
              $("#material-select-field").offset().left + 0
            );
          });
        });
      });
    },
    handleScroll() {
      window.clearInterval(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.isScrolling = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      itemType: "getNewItemType",
    }),
    getSelectedItemColor() {
      if (this.itemType === 1 || this.itemType === 3) {
        return "tertiary-color-selected";
      } else if (this.itemType === 2 || this.itemType === 4) {
        return "offer-color-selected";
      }
      return "";
    },
  },
  watch: {
    itemType() {
      this.option = JSON.parse(JSON.stringify(this.itemType));
      this.options.forEach((element) => {
        if (this.option === element.value) {
          element.isSelected = true;
        } else {
          element.isSelected = false;
        }
      });
    },
    isScrolling(val) {
      if (val === false) {
        this.selectOpen();
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    if (this.itemType) {
      this.option = this.itemType;
      this.options.forEach((element) => {
        if (this.option === element.value) {
          element.isSelected = true;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
  .trade-type-content {
    flex-wrap: nowrap;
    align-items: center;
  }
}
.title-selection {
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 16px;
}
.title-height {
  margin-top: 15px;
  height: 65px;
}
.title-size {
  max-width: 40%;
}
@media screen and (min-width: 1199px) {
  .space-itens {
    margin-left: -32px;
  }
}
@media  screen and (min-width: 1199px) and (max-width: 1280px) {
  .adjust-layout {
    min-width: 50% !important;
    max-width: 50% !important;
  }
}
@media  screen and (min-width: 1024px) and (max-width: 1199px) {
  .space-itens {
    margin-left: -24px;
  }
}
.trade-type-content {
  display: flex;
  align-items: center;
}
@media  screen and (max-width: 1024px) {
  .space-itens {
    margin-left: -24px;
  }
  .trade-type-content {
    margin-left: 0px;
  }
}
@media  screen and (max-width: 600px) {
  .space-itens {
    margin-left: -24px;
    min-width: 100px;
    max-width: 100px;

  }
}
.adjust-layout {
  min-width: 90px;
}
</style>

<style lang="scss">
.trade-type-content .md-select {
  border: 1px solid #939393 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.trade-type-content .md-field:after {
  height: 0;
}
.trade-type-content .md-field:before {
  height: 0px;
}
.tertiary-color .md-list-item-text {
  color: $tertiary !important;
}
.offer-color .md-list-item-text {
  color: $offer !important;
}
.md-list-item-text {
  font-weight: 500 !important;
}
.md-select-value {
  font-weight: 500;
  padding-left: 0.5rem !important;
}
.tertiary-color-selected .md-select-value {
  -webkit-text-fill-color: $tertiary !important;
}
.offer-color-selected .md-select-value {
  -webkit-text-fill-color: $offer !important;
}
.md-select-menu {
  z-index: 100 !important;
}
.md-select svg {
  fill: $dark !important;
}

#trade-type {
  top: 205px !important;
  margin-left: 0.5rem;
  width: 160px !important;
}
@media screen and (min-width: 1400px) {
  .md-select-menu {
    width: 155px !important;
  }
}
@media screen and (min-width: 1199px) and (max-width: 1400px) {
  .md-select-menu {
    width: 120px !important;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1198px) {
  .md-select-menu {
    width: 168px !important;
  }
}
@media screen and (min-width: 960px) and (max-width: 1023px) {
  .md-select-menu {
    width: 126px !important;
  }
}
@media screen and (min-width: 800px) and (max-width: 959px) {
  .md-select-menu {
    width: 135px !important;
  }
}
@media screen and (min-width: 769px) and (max-width: 799px) {
  .md-select-menu {
    width: 115px !important;
  }
}
@media screen and (min-width: 601px) and (max-width: 768px) {
  .md-select-menu {
    width: 115px !important;
  }
}
@media screen and (max-width: 600px) {
  .md-select-menu {
    min-width: 100px;
    max-width: 100px !important;
  }
}
</style>